import { IconLock, IconLockOpen } from '@tabler/icons-react'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'
import { Group, Text } from '@mantine/core'

interface LockableSelectItemProps extends ComponentPropsWithoutRef<'div'> {
  label: string
  locked: boolean
}

export const LockableSelectItem = forwardRef<HTMLDivElement, LockableSelectItemProps>(
  ({ label, locked, ...props }: LockableSelectItemProps, ref) => (
    <div
      ref={ref}
      {...props}
    >
      <Group
        noWrap
        spacing='xl'
        w='100%'
      >
        {locked ? <IconLock size={16} /> : <IconLockOpen size={16} />}
        <Text size='sm'>{label}</Text>
      </Group>
    </div>
  )
)

LockableSelectItem.displayName = 'LockableSelectItem'
